var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 5.79086 3.79086 4 6 4H7.5V5.2H6C4.34315 5.2 3 6.54315 3 8C3 9.45685 4.34315 10.8 6 10.8H7.5V12H6C3.79086 12 2 10.2091 2 8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8C14 10.2091 12.2091 12 10 12H8.5V10.8H10C11.6569 10.8 13 9.45685 13 8C13 6.54315 11.6569 5.2 10 5.2H8.5V4H10C12.2091 4 14 5.79086 14 8Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 7.25,
    width: 3.5,
    height: 1.5,
    rx: 0.25,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBind);
export default __webpack_public_path__ + "static/media/bind.c8cd7c8b5e0dff5d459b8869a44194c5.svg";
export { ForwardRef as ReactComponent };